export default __webpack_public_path__ + "static/media/Patient Pain and Function Assessment.20c1e6ca.pdf";